import {Component} from "react"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import environmentVariables from "shared/enviromentVariables/index.js.erb"

export default class JobFooter extends Component {
  render(){
    return(
      <footer className="page-footer font-small mdb-color pt-4 mt-5 awesome-footer">
        <Container>
          <Row className="d-flex first-section">
            <div style={{flex: 0.35}}>
              <small>
                Application built by&nbsp;
                <a href={environmentVariables.company_website} target="_blank">
                  {environmentVariables.company_name}
                </a>
              </small>
            </div>
          </Row>
          <Row className="d-flex align-items-center">
            <div className='mb-3'>
              <small>
                {environmentVariables.job_post_app_name} © {new Date().getFullYear()}
              </small>
            </div>
          </Row>
        </Container>
      </footer>
    )
  }
}
